import { render, staticRenderFns } from "./MainButtonSection.vue?vue&type=template&id=451f7813"
import script from "./MainButtonSection.vue?vue&type=script&lang=js"
export * from "./MainButtonSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports